export const apiUrl = "https://bego-consult-api.herokuapp.com";
// export const apiUrl = "https://4af3973cc816.ngrok.io";
